
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header/Header';
import ProgramDetails from './ProgramDetails/ProgramDetails';
import Footer from './Footer/Footer';
import Curriculum from './Curriculum/Curriculum.js';
import BookTrail from './BookTrail/BookTrail.js';
import Testimonial from './Testimonial/Testimonial.js';
import FAQ from './FAQ/Faq.js';
import Query from './Query/Query.js';
import Center from './Centers/Center.js';
import ExplorePlan from './ExplorePlan/ExplorePlan.js';
import PlanDetail from './PlanDetails/PlanDetail.js';
import Signup from './Signup/Signup.js';
import GetInTouch from './GetInTouch/GetInTouch.js';
import Glimpse from './Glimpse/Glimpse.js';
import UserTracker from './UserTracker.js';
import { initFacebookPixel } from './facebookPixel';
import Succesfull from './BookTrail/Succesfull.js';
import Popup from './Popup/Popup.js'
import ThankyouPage from './BookTrail/ThankyouPage.js';
import FloatingWhatsApp from './Signup/FloatingWhatsApp.js';

function App() {
  useEffect(() => {
    initFacebookPixel(); // Initialize Facebook Pixel on app load
  }, []);
  return (
    <Router>
      <div>
        
        <Routes>
          <Route path="/" element={
            <>
             <Header />
        {/* <ProgramDetails />
        <Curriculum />
        <Center/>
        <PlanDetail/>
        <Testimonial/>
        <ExplorePlan/>
        <GetInTouch/>
        <FAQ/>
        <Glimpse/>
        <Footer/>
        <Popup/> */}
        {/* <Query/> */}
        {/* <FloatingWhatsApp/>
        <Signup/> */}
            </>
          } />
          
          {/* <Route path="/book-trial" element={<>
          <BookTrail />
          </>} />
          <Route path="/SuccessPage" element={<>
          <Succesfull />
          </>} />
          <Route path="/thankyou-page" element={<>
          <ThankyouPage />
          </>} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
